import React from 'react'
import s from '../../address/AddressMainContent.less'
import FakeHotelCalendar from '../../address/FakeHotelCalendar'
import GeoentitiesAtAddressPicker from '../../address/GeoentitiesAtAddressPicker'
import { AdDesktopAddressHP } from '../../advertising/InlineDesktopAdBanner'
import { AdMobileBannerAddress } from '../../advertising/InlineMobileAdBanner'
import Footer from '../../footer/Footer'
import ZoneContent from './ZoneContent'

const ZoneMainContent = ({ titleContent }) => (
  <>
    <div className={s.addressMainContent}>
      <ZoneContent titleContent={titleContent} />
      <AdDesktopAddressHP />
      <GeoentitiesAtAddressPicker />
      <AdMobileBannerAddress />
      <FakeHotelCalendar />
    </div>
    <Footer />
  </>
)

export default ZoneMainContent
